import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { queryTypes, serviceEventTypes, serviceUserRightsTypes, serviceUserRolePermissionsTypes } from 'src/types';
import { urlHelper } from '../helpers';

export const lookupUserRolePermission = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceUserRolePermissionsTypes.UserRolePermissionLookupDataType): AxiosPromise<serviceUserRolePermissionsTypes.UserRolePermissionLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.userRolePermission.lookupUserRolePermission), {
    blockSpinner,
  });
};

export const createUserRolePermission = (
  form: serviceUserRolePermissionsTypes.UserRolePermissionCreateDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceUserRolePermissionsTypes.UserRolePermissionCreateResultType[]> => {
  return axios.post(urlsConfig.userRolePermission.createUserRolePermission, form, { blockErrorHandler: true });
};

export const editUserRolePermission = (
  form: serviceUserRolePermissionsTypes.UserRolePermissionEditDataType,
): AxiosPromise<serviceUserRolePermissionsTypes.UserRolePermissionEditResultType[]> => {
  return axios.patch(urlsConfig.userRolePermission.editUserRolePermission, form, { blockErrorHandler: true });
};

export const deleteUserRolePermission = ({
  id,
}: serviceUserRolePermissionsTypes.UserRolePermissionDeleteDataType): AxiosPromise<serviceUserRolePermissionsTypes.UserRolePermissionDeleteResultType> => {
  return axios.delete(`${urlsConfig.userRolePermission.deleteUserRolePermission}/${id}`);
};
